import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { ManageAdsBannerPhotoComponent } from "../../modules/explore/components/ads-banner-photo/manage-ads-banner-photo.component";
import {AdsTypeConstant} from "../constants/ads-type-constant";

@Injectable({
  providedIn: 'root'
})

export class AdvertisingService {
  constructor(public http: HttpClient) {
  }

  getAdvertising(partnerId?, webViewOnly = false, groupId = null, publishedOnly = false) {
    let filter: any = {
      where: {
        and : [
          {
            partnerId: partnerId ? partnerId : 1
          },
          {
            groupId: groupId
          },
          {
            or : [
              {
                type : AdsTypeConstant.FEED_ADS
              },
              {
                type : AdsTypeConstant.VIDEO_ADS
              }
            ],
          }
        ]
      },
      include : [
        {
          relation: 'group',
          scope: {
            include : 'ownerData'
          }
        }
      ],
    };

    if (groupId == 'all') {
      filter.where.and.splice(1, 1);
    }

    if (webViewOnly) {
      filter.where.and.push({
        displayView : 'web'
      })
    }

    if (publishedOnly) {
      filter.where.and.push({
        status : 'published'
      })
    }

    filter = encodeURIComponent(JSON.stringify(filter));

    return this.http.get(ManageAdsBannerPhotoComponent.ADVERTISING_URL + `?filter=${filter}`);
  }

  getPhotoAdvertising(photoId) {
      return this.http.get(ManageAdsBannerPhotoComponent.ADVERTISING_URL + `?filter[where][photoId]=${photoId}`);
  }

  clickingAds(id) {
    return this.http.put(ManageAdsBannerPhotoComponent.ADVERTISING_URL + 'advertising/'  + id + '/clicking', {});
  }
}
